/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useCellHighlight } from '../../controllers/common/index.tsx';

export const FocusHighlight: React.FC = () => {
	const [highlighted] = useCellHighlight();

	switch (highlighted) {
		case true:
			return (
				<div
					css={[highlightBaseStyles, highlightStartStyles, highlightEndStyles]}
					data-testid="portfolio-3-treegrid.ui.highlight.focus-highlight"
				/>
			);

		case 'start':
			return <div css={[highlightBaseStyles, highlightStartStyles]} />;

		case 'end':
			return <div css={[highlightBaseStyles, highlightEndStyles]} />;

		case 'middle':
			return <div css={[highlightBaseStyles]} />;

		default:
			return null;
	}
};

const highlightBaseStyles = css({
	position: 'absolute',
	inset: token('space.0'),
	borderTop: `2px solid ${token('color.border.focused')}`,
	borderBottom: `2px solid ${token('color.border.focused')}`,
	pointerEvents: 'none',
});

const highlightStartStyles = css({
	borderLeft: `2px solid ${token('color.border.focused')}`,
});

const highlightEndStyles = css({
	borderRight: `2px solid ${token('color.border.focused')}`,
});
